import { api } from '@/modules/apiv2';

export default {
  state: {
    ssoConfig: null,
  },

  getters: {
    ssoConfig(state) {
      return state.ssoConfig;
    },
  },

  mutations: {
    setSsoConfig(state, ssoConfig) {
      state.ssoConfig = ssoConfig;
    },
  },

  actions: {
    updateSsoConfig({ commit, getters }, data) {
      const endpoint = getters.ssoConfigEndpoint;

      return api
        .put(endpoint, data)
        .then((data) => {
          commit('setSsoConfig', data.SSOConfig);
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },
  },
};
